import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { PropsAndButtonAttrs, PropsAndElementAttrs } from '../../utils/ReactHelpers';
import { ButtonProps, ButtonType } from './ButtonWidget';
import { MenuButtonProps, validateMenuButtonProps } from './MenuButtonWidget';

export interface SplitButtonProps {
  /** The primary button. `buttonType` on this button will be overridden to Primary. */
  button: React.ReactElement<PropsAndButtonAttrs<ButtonProps>>;

  /** This component does not use `children`. */
  children?: never;

  /** The popup button. `children`, `aria-label` or `aria-labelledby` must be set on its props, otherwise an error will be thrown. */
  menuButton: React.ReactElement<PropsAndButtonAttrs<MenuButtonProps>>;
}

const ButtonStyleName = TypeStyle.style({
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  marginRight: `0 !important`,
});

const MenuButtonStyleName = TypeStyle.style({
  borderBottomLeftRadius: 0,
  borderTopLeftRadius: 0,
  marginLeft: `1px !important`,
  minWidth: `24px !important`,
});

const WrapperStyleName = TypeStyle.style({
  display: 'inline-flex', whiteSpace: 'nowrap'
});

/** A component which visually groups a `ButtonWidget` with a `MenuButtonWidget`. */
export const SplitButtonWidget: React.FC<PropsAndElementAttrs<SplitButtonProps>> = ({ button, menuButton, ...elemAttrs }) => {
  if (menuButton) {
    validateMenuButtonProps(menuButton.props);
  } else {
    return button;
  }

  return <div {...elemAttrs} className={TypeStyle.classes(WrapperStyleName, elemAttrs.className)}>
    {React.cloneElement(button, {
      buttonType: ButtonType.Primary,
      className: TypeStyle.classes(button.props.className, ButtonStyleName),
      density: button.props.density || 'medium',
    })}
    {React.cloneElement(menuButton, {
      kind: 'primary',
      className: TypeStyle.classes(menuButton.props.className, MenuButtonStyleName),
      density: 'high',
    })}
  </div>;
};
SplitButtonWidget.displayName = 'SplitButtonWidget';
